<template>
  <div>
    <b-modal
      id="modal-confirm"
      centered
      body-class="p-0 br-8"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      dialog-class="base-modal"
    >
      <div class="title">
        <!-- 전화번호를 입력하세요 -->
        <div>{{ $t('modal.nophone.title') }}</div>
      </div>
      <div class="modal-content">
        <!-- 한 전화번호당 한 계정만 인증하실 수 있습니다. -->
        <div>{{ $t('modal.nophone.content') }}</div>
        <b-form-group v-if="modal_second" class="mb-2 mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <vue-tel-input
              v-model="new_phone"
              :placeholder="$t('mypage.userinfo.phoneerr')"
              style="box-shadow: none; width: 100%; font-size: 16px; height: 37px"
              @input="handleInput"
            />
          </div>
          <div v-if="phone_send_auth" class="font-s14 text-danger text-left mt-1">
            {{ phone_send_auth }}
          </div>
        </b-form-group>
        <div v-if="!openAuthForm">
          <VueRecaptcha v-bind="{ verify: onCaptchaVerified, location: 'nophone' }" />
        </div>
        <b-form-group v-if="openAuthForm" class="mb-2 mt-3">
          <b-input-group class="auth_input_group">
            <!-- 인증번호를 입력해주세요 -->
            <b-form-input
              v-model="phone_auth_num"
              size="sm"
              style="font-size: 16px; height: 37px"
              :placeholder="$t('modal.nophone.placeholder')"
            />
            <template #append>
              <span class="auth_timer_time">{{ auth_timer_time }}</span>
            </template>
          </b-input-group>
        </b-form-group>
      </div>

      <!-- 버튼 UI -->
      <div class="btn-wrapper cancel-on">
        <div class="modal-btn cancel" @click="authClickCancel">
          <!-- 취소 -->
          {{ $t('modal.cancel') }}
        </div>
        <div class="modal-btn confirm" @click="authClickConfirm">{{ authModalConfirm }}</div>
      </div>
      <!-- 버튼 UI -->
    </b-modal>

    <BaseModal
      id="authModal"
      :cancel-btn="cancelBtn"
      :no-content="noContent"
      :no-close="noClose"
      @clickConfirm="clickConfirm"
      @clickCancel="clickCancel"
    >
      <template slot="title"><div v-html="modalTitle" /></template>
      <template slot="content"><div v-html="modalContent" /></template>
      <template slot="cancel"><div v-html="$t(modalCancel)" /></template>
      <template slot="confirm"><div v-html="$t(modalConfirm)" /></template>
    </BaseModal>
  </div>
</template>

<script>
import { IS_LOCAL } from '@/helpers';
import { mapMutations, mapState, mapActions } from 'vuex';
import { Pagination } from '@egjs/flicking-plugins';
import BaseModal from '@/views/Modal/BaseModal.vue';
import VueRecaptcha from '@/views/Components/Recaptcha.vue';

export default {
  name: 'NoPhone',
  components: {
    BaseModal,
    VueRecaptcha,
  },
  filters: {
    comma_num(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  data() {
    return {
      modal_second: true, // 전화번호 입력 모달일 경우 true, 인증번호 입력 모달일 경우 false
      phone_auth_num: null, // 인증번호 입력값
      phone_send_auth: null,
      openAuthForm: false,
      auth_timer_time: '05:00',
      arr_timer: [],
      seconds: 299,
      timer_id: null,
      modal_content: '',
      modal_cancel: true,
      modal_ok_submit: null,
      modal_ok: '',
      plugin: [new Pagination({ type: 'bullet' })],
      new_phone: null, // 전화번호 입력값
      country_code: null, // 국가코드
      new_phone_num: null, // 정제된 전화번호 입력값
      phoneValid: null, // 전화번호 유효성 검사결과
      isPhoneAuth: true,
      // 모달 관련 변수
      modalState: '',
      modalTitle: '',
      modalContent: '',
      modalCancel: 'modal.cancel',
      modalConfirm: 'modal.confirm',
      cancelBtn: false,
      noContent: false,
      noClose: false,
      // 인증 모달 관련 변수
      authModalConfirm: '', // 인증모달 확인 버튼 텍스트
      authModalState: '', // 인증모달 상태
      captchaVerified: false, // reCAPTCHA 체크 완료 여부
    };
  },
  computed: {
    ...mapState({
      isPhone: (state) => state.isPhone,
      isMobile: (state) => state.isMobile,
    }),
  },
  created() {
    if (!this.isPhone) {
      this.modalTitle = this.$t('modal.nophone.modaltitle');
      this.cancelBtn = true;
      this.modalConfirm = 'modal.nophone.confirm1';
      this.modalContent = this.$t('modal.nophone.modalcontent');
      this.modalState = 'authConfirmModal';
      setTimeout(() => {
        this.$bvModal.show('authModal');
      }, 100);
    }
  },
  methods: {
    ...mapMutations(['setPhoneAuthModalState']),
    ...mapActions(['delay']),
    /** 전화번호 입력 시 이벤트 함수 */
    handleInput($event, $phoneInfo) {
      this.phoneValid = $phoneInfo && $phoneInfo.valid;
      this.new_phone_num = $phoneInfo && $phoneInfo.country?.dialCode === '82' ? $event : $phoneInfo.nationalNumber;
      this.country_code = $phoneInfo && $phoneInfo.country?.dialCode;
    },
    /** captcha 통과 확인 */
    onCaptchaVerified(check) {
      // console.log('NoPhone, onCaptchaVerified: ', check);
      this.captchaVerified = check;
    },
    /** POST: 전화번호 인증 요청 */
    async phoneAuth() {
      console.log(`captchaVerified : ${this.captchaVerified}`);

      if (IS_LOCAL) {
        this.openAuthForm = true;
        this.auth_timer_start();
        this.modal_second = false;
        this.captchaVerified = true;

        this.authModalConfirm = this.$t('modal.nophone.confirm1');
        this.authModalState = 'authSendModal';
        return;
      }

      if (!this.captchaVerified) {
        // CAPTCHA 확인이 필요합니다. 계속하려면 체크박스를 선택해주세요
        this.modalTitle = this.$t('modal.nophone.verify.error.captcha');
        this.noContent = true;
        this.isPhoneAuth = true;
        this.$bvModal.show('authModal');
        return;
      }

      if (this.isPhoneAuth && this.captchaVerified) {
        this.isPhoneAuth = false;
        let regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
        if (!this.new_phone || !this.phoneValid || (this.country_code === '82' && !regPhone.test(this.new_phone))) {
          this.modalTitle = this.$t('mypage.userinfo.phoneerr');
          this.noContent = true;
          this.isPhoneAuth = true;
          this.$bvModal.show('authModal');
          return;
        }

        try {
          await this.$axios.post(`${process.env.VUE_APP_TEST_SERVER}/send_auth_num`, {
            phone_number: this.new_phone_num,
            country_code: this.country_code,
          });

          //this.phone_send_auth = "* 인증번호를 발송했습니다.";
          this.captchaVerified = false;
          this.openAuthForm = true;
          this.auth_timer_start();
          this.modal_second = false;

          this.authModalConfirm = this.$t('modal.nophone.confirm1');
          this.authModalState = 'authSendModal';
        } catch (err) {
          const {
            status,
            data: { message },
          } = err.response;

          if (status === 401) return this.$bvModal.show('login-required');

          this.isPhoneAuth = true;
          this.cancelBtn = false;
          this.modalState = 'authMissModal';
          this.modalTitle = message.title;
          this.modalContent = message.content.replace('|', '<br>');
          this.noClose = true;

          this.$bvModal.show('authModal');
        }
      }
    },
    /** POST: 인증번호 보내기 */
    async phoneChange() {
      // if (IS_LOCAL) {
      //   const err = {
      //     response: {
      //       status: 500,
      //       data: {
      //         message: null,
      //         cntAuth: 3,
      //         cntAuthCheck: 5,
      //       },
      //     },
      //   };

      //   const {
      //     status,
      //     data: { message, cntAuth, cntAuthCheck },
      //   } = err.response;

      //   if (status === 401) return this.$bvModal.show('login-required');

      //   this.isPhoneAuth = true;
      //   this.noClose = true;
      //   this.cancelBtn = false;

      //   // error message가 있는 경우 error message를 띄움
      //   if (message !== null) {
      //     this.modalTitle = message.title;
      //     this.modalContent = message.content.replace('|', '<br>');

      //     return this.$bvModal.show('authModal');
      //   }

      //   // 인증번호를 5회 미만 틀렸을 경우
      //   if (cntAuthCheck < 5) {
      //     this.modalTitle = this.$t('modal.nophone.verify.error.title', { num: cntAuthCheck });
      //     this.modalContent = this.$t('modal.nophone.verify.error.content');
      //   }
      //   // 인증요청이 3번째인 상태에서 5회 틀렸을 경우
      //   else if (cntAuth === 3) {
      //     this.modalState = 'authMissModal';
      //     this.modalTitle = this.$t('modal.nophone.verify.fail.title');
      //     this.modalContent = this.$t('modal.nophone.verify.fail.done');
      //   }
      //   // 인증요청이 3번째 미만인 상태에서 5회 틀렸을 경우
      //   else {
      //     this.modalState = 'authFailModal';
      //     this.modalTitle = this.$t('modal.nophone.verify.fail.title');
      //     this.modalContent = this.$t('modal.nophone.verify.fail.retry');
      //     this.cancelBtn = true;
      //     this.modalConfirm = this.$t('modal.nophone.confirm');
      //     this.modalCancel = 'modal.confirm';
      //   }

      //   this.$bvModal.show('authModal');
      //   return;
      // }

      // 인증번호를 입력하지 않은 경우
      if (!this.phone_auth_num) {
        // 인증번호를 입력해주세요
        this.modalTitle = this.$t('modal.nophone.placeholder');
        this.noContent = true;
        this.$bvModal.show('authModal');
        return;
      }
      // 인증중
      this.$store.commit('startSpinner', { content: this.$t('modal.nophone.spinner') });
      await this.delay(300);

      try {
        await this.$axios.post(`${process.env.VUE_APP_TEST_SERVER}/check_auth_num`, {
          phone_number: this.new_phone_num,
          country_code: this.country_code,
          auth_num: this.phone_auth_num,
        });

        clearInterval(this.arr_timer[0]);
        this.isPhoneAuth = true;
        this.auth_timer_time = '05:00';
        this.openAuthForm = false;
        // 전화번호 인증에 성공했습니다
        this.modalTitle = this.$t('modal.nophone.success.title');
        // 전화번호 인증이 성공적으로 완료되었습니다.</br />내 자산을 확인해보세요.
        this.modalContent = this.$t('modal.nophone.success.content');
        this.modalState = 'authSuccessModal';
        this.$bvModal.hide('modal-confirm');
        this.$bvModal.show('authModal');
      } catch (err) {
        const {
          status,
          data: { message, cntAuth, cntAuthCheck },
        } = err.response;

        if (status === 401) return this.$bvModal.show('login-required');

        this.isPhoneAuth = true;
        this.noClose = true;
        this.cancelBtn = false;

        // error message가 있는 경우 error message를 띄움
        if (message !== null) {
          this.modalTitle = message.title;
          this.modalContent = message.content.replace('|', '<br>');

          return this.$bvModal.show('authModal');
        }

        // 인증번호를 5회 미만 틀렸을 경우
        if (cntAuthCheck < 5) {
          // 인증번호 입력 {num}회 오류입니다.
          this.modalTitle = this.$t('modal.nophone.verify.error.title', { num: cntAuthCheck });
          // ※ 인증번호 입력은 최대 5회까지 가능합니다.
          this.modalContent = this.$t('modal.nophone.verify.error.content');
        }
        // 인증요청이 3번째인 상태에서 5회 틀렸을 경우
        else if (cntAuth === 3) {
          this.modalState = 'authMissModal';
          // 번호인증에 실패했습니다
          this.modalTitle = this.$t('modal.nophone.verify.fail.title');
          // 인증번호 요청 횟수를 초과했습니다.<br/>고객센터로 문의해 주세요.
          this.modalContent = this.$t('modal.nophone.verify.fail.done');
        }
        // 인증요청이 3번째 미만인 상태에서 5회 틀렸을 경우
        else {
          this.modalState = 'authFailModal';
          // 번호인증에 실패했습니다
          this.modalTitle = this.$t('modal.nophone.verify.fail.title');
          // 5회 연속 인증번호를 잘못 입력하셨습니다.<br/>번호인증을 재시도하세요.
          this.modalContent = this.$t('modal.nophone.verify.fail.retry');
          this.cancelBtn = true;
          // 인증하기
          this.modalConfirm = this.$t('modal.nophone.confirm');
          this.modalCancel = 'modal.confirm';
        }

        this.$bvModal.show('authModal');
        return;
      } finally {
        this.$store.commit('endSpinner');
        this.phone_auth_num = null;
      }
    },
    /** 초를 분:초로 formatting */
    seconds_to_mins(seconds) {
      let min = parseInt((seconds % 3600) / 60);
      let sec = seconds % 60;

      if (min < 10) {
        min = '0' + min;
      }
      if (sec < 10) {
        sec = '0' + sec;
      }

      return min + ':' + sec;
    },
    /** 남은 시간 계산 */
    display_remains(seconds) {
      let str = this.seconds_to_mins(seconds);
      this.auth_timer_time = str;
    },
    timer_down(count) {
      count -= 1;
      return count;
    },
    /** 인증번호 입력 제한시간 START */
    auth_timer_start() {
      let start_time;

      if (this.arr_timer.length == 0) {
        let timer_id = setInterval(() => {
          if (this.arr_timer.length == 0) {
            this.arr_timer.push(timer_id);
            start_time = new Date();
          }

          let now = new Date();
          let time_diff =
            (now.getMinutes() - start_time.getMinutes()) * 60 + now.getSeconds() - start_time.getSeconds();
          let remain_secs = this.timer_down(this.seconds - time_diff);

          if (remain_secs < 0) {
            remain_secs = 0;
            this.arr_timer = [];
            clearInterval(timer_id);
          }

          this.display_remains(this.seconds - time_diff);

          if (this.seconds - time_diff === 0) {
            this.modal_second = true;
            this.openAuthForm = false;
            this.phone_auth_num = null;
            this.auth_timer_time = '05:00';
            this.isPhoneAuth = true;
            // 인증하기
            this.authModalConfirm = this.$t('modal.nophone.confirm');
            this.authModalState = 'authModal';
            clearInterval(this.arr_timer[0]);
          }
        }, 1000);
      } else {
        clearInterval(this.arr_timer[0]);
        this.arr_timer = [];
        this.seconds = 299;
        this.auth_timer_start();
      }
    },
    closeModal() {
      this.$store.commit('toggleGuideModal', { state: false });
    },
    /** 인증 모달 확인 버튼 동작 */
    async authClickConfirm() {
      switch (this.authModalState) {
        case 'authModal':
          await this.phoneAuth();
          break;
        case 'authSendModal':
          await this.phoneChange();
          break;
      }
    },
    /** 인증 모달 취소 버튼 동작 */
    authClickCancel() {
      this.$bvModal.hide('modal-confirm');
      setTimeout(() => {
        this.setPhoneAuthModalState({ shown: false });
      }, 300);
    },
    /** 모달 확인 버튼 동작 */
    clickConfirm() {
      switch (this.modalState) {
        case 'authSuccessModal':
          this.$store.commit('toggleIsPhone', {});
          this.$bvModal.hide('authModal');
          setTimeout(() => {
            this.setPhoneAuthModalState({ shown: false });
          }, 300);
          break;
        case 'authConfirmModal':
          this.$bvModal.hide('authModal');
          this.$bvModal.show('modal-confirm');
          // 인증하기
          this.authModalConfirm = this.$t('modal.nophone.confirm');
          this.authModalState = 'authModal';
          break;
        // 인증번호 5회 틀리고 전화번호 요청건이 3회 미만인 경우
        case 'authFailModal':
          this.$bvModal.hide('authModal');
          this.$bvModal.show('modal-confirm');

          this.authModalState = 'authModal';
          // 인증하기
          this.authModalConfirm = this.$t('modal.nophone.confirm');
          this.openAuthForm = false;
          this.modal_second = true;
          clearInterval(this.arr_timer[0]);
          break;
        // 인증번호 5회 틀리고 전화번호 요청건이 3회인 경우
        case 'authMissModal':
          this.$bvModal.hide('authModal');
          this.authClickCancel();
          break;
      }
      // 모달 닫기 및 초기화
      this.$bvModal.hide('authModal');
      setTimeout(() => {
        this.modalState = '';
        this.modalTitle = '';
        this.modalContent = '';
        this.modalCancel = 'modal.cancel';
        this.modalConfirm = 'modal.confirm';
        this.cancelBtn = false;
        this.noContent = false;
      }, 200);
    },
    /** 모달 취소 버튼 동작 */
    clickCancel() {
      switch (this.modalState) {
        case 'authConfirmModal':
          this.$bvModal.hide('authModal');
          setTimeout(() => {
            this.setPhoneAuthModalState({ shown: false });
          }, 300);
          return;
        // 인증번호 5회 틀리고 전화번호 요청건이 3회 미만인 경우
        case 'authFailModal':
          this.$bvModal.hide('authModal');
          this.authClickCancel();
          return;
      }

      this.$bvModal.hide('authModal');
      setTimeout(() => {
        this.modalState = '';
        this.modalTitle = '';
        this.modalContent = '';
        this.modalCancel = 'modal.cancel';
        this.modalConfirm = 'modal.confirm';
        this.cancelBtn = false;
        this.noContent = false;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
#modal-confirm {
  .modal-content {
    padding-right: 28px;
    @include tablet {
      padding-right: 22px;
    }
  }
}
</style>

<style lang="postcss">
.no-phone-modal {
  font-style: normal;
  font-weight: normal;
  text-align: center;
}
.no-phone-modal.title {
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.4px;
  color: #333333;
}
.no-phone-modal.title .fail {
  color: #e21414;
}
.no-phone-modal.title .success {
  color: #4480e2;
}
.no-phone-modal.contents {
  font-size: 14px;
  line-height: 15px;
  letter-spacing: -0.5px;
  color: #999999;
}
.close_modal {
  cursor: pointer;
}
.auth_input_group {
  display: inline-block;
  border: 1px solid #d5dce1;
  border-radius: 0.25rem;
}
.auth_input_group input {
  border: 0;
  width: 85% !important;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.auth_input_group .input-group-append {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
}
.auth_input_group .auth_timer_time {
  color: #d52c2c;
  font-size: 13px;
}
.br-8 {
  border-radius: 8px;
}
</style>
